import React, { FunctionComponent } from "react";
import { useIsInteractiveAnalysisActive } from "../../hooks";
import { route } from "../../../../../../shim/jsbridge";
import { Link } from "../../../../../../components/link";

type InteractiveAnalysisLinkProps = {
  hash?: string;
  uploadId?: number;
  url?: string;
};

const getRedirectUrlByType = (
  type: string,
  hash?: string,
  uploadId?: number,
  url?: string,
  urlAnalysisSha1?: string,
  urlAnalysisId?: string
): string => {
  if (type === "hash") {
    return route("rl_interactive_analysis_for_hash", [hash]);
  } else if (type === "uploadId") {
    return route("rl_interactive_analysis_for_upload", [uploadId]);
  } else {
    return route("rl_interactive_analysis_for_url", [
      encodeURIComponent(url as string),
      urlAnalysisSha1,
      urlAnalysisId
    ]);
  }
};

const getRedirectLinkByType = (
  type?: string,
  hash?: string,
  uploadId?: number,
  url?: string,
  urlAnalysisSha1?: string,
  urlAnalysisId?: string
) => {
  if (!type) {
    return null;
  } else {
    const redirectUrlByType = getRedirectUrlByType(
      type,
      hash,
      uploadId,
      url,
      urlAnalysisSha1,
      urlAnalysisId
    );

    return (
      <Link to={redirectUrlByType} className={"align-self-center"}>
        View&nbsp;active&nbsp;Interactive&nbsp;Analysis
      </Link>
    );
  }
};

const InteractiveAnalysisLink: FunctionComponent<
  InteractiveAnalysisLinkProps
> = ({ hash, uploadId, url }) => {
  const {
    data: { type, is_active: isActive, urlAnalysisSha1, urlAnalysisId },
    isLoading
  } = useIsInteractiveAnalysisActive({
    hash,
    uploadId,
    url
  });

  return isActive && !isLoading
    ? getRedirectLinkByType(
        type,
        hash,
        uploadId,
        url,
        urlAnalysisSha1,
        urlAnalysisId
      )
    : null;
};

export default InteractiveAnalysisLink;
